import { EmailThreadItem, ReplyForwardEditorAction } from '../../../type';

export const getReplyForwardEmailEditor = (
  action: ReplyForwardEditorAction,
): string => {
  if (action === 'reply') {
    return 'Reply email';
  }
  if (action === 'replyAll') {
    return 'Reply All';
  }
  if (action === 'forward') {
    return 'Forward email';
  }
  return '';
};

export const getAllEmailRecipients = (
  emailThread: EmailThreadItem,
): string[] => {
  const recipients = (emailThread.to || []).concat(
    emailThread.cc,
    emailThread.bcc,
  );
  return recipients || [];
};
